import React from 'react'
import { warm700, warm300 } from './tokens'

type Props = { items: string[] }

export const TrustStrip: React.FC<Props> = ({ items }) => (
  <div className="py-3.5 flex justify-center gap-8 md:gap-16 flex-wrap px-8" style={{ background: warm700 }}>
    {items.map((item, i) => (
      <div key={i} className="flex items-center gap-2" style={{ color: '#fdf8f2' }}>
        <span style={{ color: warm300 }}>✦</span>
        <span className="text-[0.78rem] font-medium tracking-[0.08em] uppercase">{item}</span>
      </div>
    ))}
  </div>
)
